//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionUpload(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 10.73V13.34L11 9.14V19H13V9.14L18 13.34V10.73L12 5.73L6 10.73ZM21 4V2H3V4H21Z" fill="currentColor" /></svg>;
}
export default IconActionUpload;